import React from "react";
import {useSelector} from "react-redux";
import SingleInfoSection from "../Profile/singleInfoSection";
import ComponentHeader from "../CommonComponents/componentHeader";
import ShareLinks from "./shareLinks";

const PARTNER_CODE_AND_LINK_COMPONENT = "PARTNER_CODE_AND_LINK_COMPONENT";

const PartnerCodeAndLinksWrapper = () => {
    const partnerDetails = useSelector(state => state.partnerDetails);
    const referralLink = useSelector(state => state.referralLink);
    if (partnerDetails === null)
        return <></>

    return (
        <>
            <ComponentHeader title="Partner Code and Links"/>
            <div className="mx-auto d-flex justify-content-center">
                <div className="info-container mt-3 lh-lg">
                    <SingleInfoSection label={"Partner Code:"} info={partnerDetails.partnerCode} showCopyBtn={true}
                                       copyBtnText={"Copy code"}/>
                    <SingleInfoSection label={"Partner Referral Link For Signup:"} info={referralLink}
                                       showCopyBtn={true} copyBtnText={"Copy"}/>
                </div>
            </div>
            <div className="mx-auto d-flex justify-content-center mt-12">
                <ShareLinks />
            </div>
        </>
    )
}

export default PartnerCodeAndLinksWrapper;
export {PARTNER_CODE_AND_LINK_COMPONENT};
